
<div class='word-cloud-container' *ngIf="data?.brands?.length">
    <app-word-cloud-card
        *ngFor="let brand of data?.brands || []"
        [data]="brand.words"
        [brandKey]="brand.brandKey"
        [brandName]="brand.brandName"
        [brandLogo]="brand.logoPath"
        [brandColor]="brandColors?.[brand.brandKey]"
        [chartWidth]="brandWidthMap?.[brand.brandKey] || 342">
    </app-word-cloud-card>
</div>
<app-loader *ngIf="loading"></app-loader>
<app-no-widget-data [class]="'wide-container'" *ngIf="!data?.brands?.length && !loading"></app-no-widget-data>

